function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_addressbook");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_addressbook",
  stroke: "#061A32"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path_1188",
  points: "27 30.5 3 30.5 3 0.5 27 0.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,4.5 L0,4.5",
  id: "Line_114"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,10 L0,10",
  id: "Line_115"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,15.5 L0,15.5",
  id: "Line_116"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,21 L0,21",
  id: "Line_117"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,26.5 L0,26.5",
  id: "Line_118"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3,15.6 L14.2,15.6 C14.2,15.6 11,15.6 11,18.2 L11,23.5",
  id: "Path_1189"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7,15.6 L17.8,15.6 C17.8,15.6 21,15.6 21,18.2 L21,23.5",
  id: "Path_1190"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_71",
  cx: 16,
  cy: 10.6,
  r: 2.6
})));

var SvgIconAddressbook = function SvgIconAddressbook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "31px",
    viewBox: "0 0 28 31",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddressbook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_addressbook.ba0ce881.svg";
export { ForwardRef as ReactComponent };